module.exports = __webpack_public_path__ + "media/packs/images/flags/EC-16b6010a8ab37169816477fde20c42af.png";